
  import * as imageCdnRuntime$_3PFBe1fekflxemGQOon3H04cdRYsHCoGfVNvmiCE4VU from '/opt/render/project/src/apps/frontend/providers/imageCdn.ts'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "imageCdn",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    providers: {
        ['imageCdn']: { provider: imageCdnRuntime$_3PFBe1fekflxemGQOon3H04cdRYsHCoGfVNvmiCE4VU, defaults: undefined }
    }
  }
